import routerOptions0 from "/opt/buildagent/work/9e6a59290f45540b/node_modules/.pnpm/nuxt@3.18.1_@electric-sql+pglite@0.4.5_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@type_3656b55b92f14737bd73d3e678494319/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}